/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Breadcrumb_HomeInputs */

const en_layout_breadcrumb_home = /** @type {(inputs: Layout_Breadcrumb_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

const pl_layout_breadcrumb_home = /** @type {(inputs: Layout_Breadcrumb_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

/**
* | output |
* | --- |
* | "Home" |
*
* @param {Layout_Breadcrumb_HomeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const layout_breadcrumb_home = /** @type {((inputs?: Layout_Breadcrumb_HomeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Breadcrumb_HomeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_layout_breadcrumb_home(inputs)
	return en_layout_breadcrumb_home(inputs)
});